import { createReducer } from '@reduxjs/toolkit';

import { hideAside, showAside, toggleAside } from './actions';

const asideReducer = createReducer(false, (builder) => {
  builder
    .addCase(hideAside, () => false)
    .addCase(showAside, () => true)
    .addCase(toggleAside, (state, action) => action.payload);
});

export default asideReducer;
